export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <span className="brand-mark" aria-hidden />
          <span>
            Easy School <span className="brand-name">Payments</span>
          </span>
        </div>
        <nav className="footer-links" aria-label="Footer">
          <a href="#features">Features</a>
          <a href="#how-it-works">How it works</a>
          <a href="#contact">Contact</a>
        </nav>
        <p className="footer-meta">&copy; {year} Easy School Payments. All rights reserved.</p>
      </div>
    </footer>
  );
}
